<mat-card class="product-card" *ngIf="product">
    <a
        class="p-link"
        [routerLink]="['/' + lang + '/products/' + product.slug_name]"
    >
        <img  loading="lazy" 
            width="626"
            height="800"
            mat-card-image
            [src]="product?.image"
               [alt]="product?.name"
        />
    </a>
    <div
        class="wishlist-icon {{ index }}-wishlist"
        id="{{ type }}-{{ index }}-wishlist"
    >
        <a
            (click)="
                productAddToWishlist(product, type + '-' + index + '-wishlist')
            "
        >
            <mat-icon class="material-icons favorite"> favorite </mat-icon>
        </a>
    </div>
    <mat-card-content class="product-content relative">
        <h5>
            <a
                [routerLink]="['/' + lang + '/products/' + product.slug_name]"
                class="title-link"
                >{{ lang == "ar" ? product?.name_ar : product?.name_en }}</a
            >
        </h5>
        <div>
            <div fxFlex fxLayoutAlign="space-between">
                <h6 class="accent-color">
                    {{ product?.price | currency: currency }}
                </h6>
                <div class="rating-star">
                    <embryo-Rating [rate]="product.rating"></embryo-Rating>
                </div>
            </div>
        </div>
        <div class="m-icon" *ngIf="checkCartAlready(product)">
            <embryo-AddToCardButton
                [product]="product"
                (addToCart)="addToCartProduct($event)"
            ></embryo-AddToCardButton>
        </div>
        <div class="m-icon" *ngIf="!checkCartAlready(product)">
            <a [routerLink]="['/' + lang + '/products/' + product.slug_name]">
                <button mat-fab>
                    <mat-icon class="material-icons"> remove_red_eye </mat-icon>
                </button>
            </a>
        </div>
    </mat-card-content>
</mat-card>
